import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Resume } from 'src/app/models/configurators-2d/resume/resume';
import { ClosetDoorsCustomPreviewComponent } from '../preview/preview.component';
import { ClosetDoorsCustomService } from 'src/app/services/configurators-2d/applications/closet-doors-custom.service';
import { ClosetDoorsCustomConfiguratorItem } from '../../../configurator/applications/closet-doors-custom-configurator-item';
import { IBaseComponent } from '../../../configurator/i-base-component';
import { Configurators2DComponent } from '../../../configurators-2d.component';
import { Ean } from 'src/app/models/configurators-2d/resume/ean';
import { MODAL, ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'ng-closet-doors-custom-summary',
  templateUrl: './summary.component.html',
})
export class ClosetDoorsCustomSummaryComponent
  extends ClosetDoorsCustomConfiguratorItem
  implements OnInit, IBaseComponent
{
  currentLang: string;

  products: {
    categoryNameFr: string;
    categoryNameEn: string;
    items: {
      nameFr: string;
      nameEn: string;
      quantity: number;
    }[];
  }[] = [];

  preview: ClosetDoorsCustomPreviewComponent;

  constructor(
    private translate: TranslateService,
    closetDoorCustomService: ClosetDoorsCustomService,
    configurators2DComponent: Configurators2DComponent,
    private modalService: ModalService
  ) {
    super(closetDoorCustomService);
    this.preview = configurators2DComponent.preview as ClosetDoorsCustomPreviewComponent;
  }

  ngOnInit(): void {
    this.currentLang = this.translate.getBrowserLang();
    this.configuration.resume = undefined;
    this.configuration.isComplete = true;
    this.service.getResume<Resume>().then(() => {
      if (this.configuration.resume.hasPriceError) {
        this.modalService.display(MODAL.GENERIC_ERROR, {
          errorMessage:
            this.translate.instant('closet-doors-custom.error.price', {
              supplierName: this.configuration.supplier.name,
            }) + ` (${this.configuration.resume.priceErrorCode})`,
        });
      }

      if (this.preview.isPreviewLoading == null) {
        this.preview.getProfilesImages();
        this.preview.update();
      }
    });
  }

  getCategories(): string[] {
    let categories = [...new Map(this.configuration.resume.products.map(cp => [cp['categoryName'], cp])).values()];

    return categories.map(cp => cp['categoryName']);
  }

  getProducts(categoryName: string): Ean[] {
    return this.configuration.resume.products.filter(e => e['categoryName'] === categoryName);
  }

  checkPageChangeCapability(): boolean {
    return (
      this.configuration.frame != null &&
      !this.configuration.frame.isDisabled &&
      !this.configuration.frameFinish.isDisabled &&
      !this.configuration.doorRange.isDisabled &&
      this.configuration.frameFinish != null &&
      !this.configuration.checkAccessories &&
      this.checkRequiredAccessoriesIsSelected() &&
      (this.configuration.hasQuotation || !this.configuration.hasDisabledProducts) &&
      this.configuration.configurationDoorStructures?.every(
        ds =>
          !ds.doorStructure.isDisabled &&
          ds.configurationDoorSections.every(
            s =>
              !s.color.isDisabled &&
              !s.doorSection.colorCategories.find(cc => cc.id === s.color.colorCategoryId).isDisabled
          )
      )
    );
  }

  private checkRequiredAccessoriesIsSelected(): boolean {
    if (!this.configuration.requiredAccessoryTypes) {
      return false;
    }

    if (this.configuration.requiredAccessoryTypes.length === 0) {
      return true;
    }

    const accessoryTypeIds = this.configuration.configurationAccessories.map(ca => ca.accessory.accessoryTypeId);

    return this.configuration.requiredAccessoryTypes.some(ac => ac.isRequired && accessoryTypeIds.includes(ac.id));
  }

  isNextButtonActive(): boolean {
    return true;
  }
}
